<template>
    <div id="container">
        <div id="site-title">
            <h1>SVG PATTERN MAKER</h1>
            <a href="//www.webopixel.net">Created by webOpixel</a>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" id="pattern-box">
            <defs>
                <pattern
                    id="pattern"
                    :x="params.size"
                    :y="params.size"
                    :width="params.marginX"
                    :height="params.marginY"
                    patternUnits="userSpaceOnUse"
                    :patternTransform="rotateString"
                    v-if="selectType === 'path'">
                    <line
                        x1="0" y="0"
                        x2="0" :y2="params.size"
                        :stroke="params.strokeColor" :stroke-width="params.strokeWidth"/>
                </pattern>
                <pattern
                    id="pattern"
                    :x="params.size"
                    :y="params.size"
                    :width="params.margin"
                    :height="params.margin"
                    patternUnits="userSpaceOnUse"
                    :patternTransform="rotateString"
                    v-else>
                    <circle
                        :cx="centerPoint"
                        :cy="centerPoint"
                        :r="params.size - params.strokeWidth"
                        :fill="params.fillColor"
                        :stroke="params.strokeColor"
                        :stroke-width="params.strokeWidth"
                        v-if="selectType === 'circle'"/>
                    <rect
                        :x="params.strokeWidth/2"
                        :y="params.strokeWidth/2"
                        :width="params.size"
                        :height="params.size"
                        :fill="params.fillColor"
                        :stroke="params.strokeColor"
                        :stroke-width="params.strokeWidth"
                        v-else-if="selectType === 'rect'"/>
                </pattern>
            </defs>
            <rect :fill="params.bgColor" width="100%" height="100%" v-if="params.bgColor"/>
            <rect fill="url(#pattern)" x="0" y="0" width="100%" height="100%"></rect>
        </svg>
        <Sidebar :selectType="selectType" :params="params" @onTypeChange="onTypeChange"/>
<!--        <div class="ad">
            <Adsense
                data-ad-client="ca-pub-9923893151467229"
                data-ad-slot="1662514737">
            </Adsense>
        </div>-->
    </div>
</template>

<script>
    import Sidebar from './Sidebar';

    export default {
        data() {
            return {
                selectType: 'circle',
                params: {
                    makeTypes: [{
                        value: 'circle',
                        label: '丸'
                    }, {
                        value: 'rect',
                        label: '四角'
                    }, {
                        value: 'path',
                        label: 'ライン'
                    }],
                    size: 6,
                    fillColor: '#333',
                    margin: 30,
                    bgColor: '',
                    datetime: '',
                    strokeColor: '',
                    strokeWidth: 0,
                    marginX: 10,
                    marginY: 10,
                    rotate: 0
                }
            }
        },
        components: {
            Sidebar
        },
        computed: {
            centerPoint() {
                return this.params.margin / 2
            },
            rotateString() {
                return 'rotate(' + this.params.rotate + ')'
            }
        },
        methods: {
            onTypeChange(inputType) {
                // 選択タイプの切り替え
                this.selectType = inputType;

                this.params.size = 10;
                this.params.strokeWidth = 0;
                this.params.strokeColor = '';
                this.params.rotate = 0;

                // 選択したものがラインの場合は斜めにする
                if (this.selectType === 'path') {
                    this.params.strokeWidth = 5;
                    this.params.marginX = 15;
                    this.params.strokeColor = '#333';
                    this.params.rotate = 45;
                }
            },
            pngSave() {
                // const fileName = 'pattern.png';
                //
                // // const content = document.querySelector('#pattern-box').outerHTML;
                // const content = document.querySelector('#pattern-box');
                //
                // const dataUri = "data:image/svg+xml;utf8," + encodeURIComponent( (new XMLSerializer()).serializeToString(content) );
                //
                // const canvas = document.createElement('canvas');
                // // canvas.width = content.width.baseVal.value;
                // // canvas.height = content.height.baseVal.value;
                //
                // if (this.selectType === 'path') {
                //     canvas.width = this.marginX;
                //     canvas.height = this.marginY;
                // } else {
                //     canvas.width = this.margin;
                //     canvas.height = this.margin;
                // }
                //
                //
                // const context = canvas.getContext('2d');
                //
                // const download = () => {
                //     context.drawImage(img, 0, 0);
                //     const url = canvas.toDataURL("image/png");
                //
                //     const a = document.createElement('a');
                //     a.download = fileName;
                //     a.href = url;
                //     document.body.appendChild(a);
                //     a.click();
                //     document.body.removeChild(a);
                // };
                //
                // const img = new Image();
                // img.src = dataUri;
                // img.addEventListener('load', download, false);
            },

        }
    }
</script>


<style scoped lang="scss">
    #container {
        height: 100%;
    }
    #site-title {
        position: fixed;
        display: inline-block;
        background: #fff;
        left: 10px;
        top: 10px;
        padding: 10px 15px;
        margin: 0;
        line-height: 1;
        font-weight: bold;
        box-shadow: 5px 5px 0 rgba(0,0,0,.1);

        h1 {
            margin: 0 0 3px;
            font-size: 20px;
            color: #000;
        }
        a {
            text-decoration: none;
            color: #000;
            font-size: 12px;
            display: inline-block;

            &:hover {
                background: #333;
                color: #fff;
            }
        }
    }
    .ad {
        position: fixed;
        z-index: 100;
        left: 0;
        bottom: 0;
        /*width: 728px;*/
        width: calc(100% - 320px);
        height: 90px;
        text-align: center;

        .adswrapper {
            width: 728px;
            margin: 0 auto;
        }
    }
</style>
